var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderSimpleLock = function SvgIconFolderSimpleLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25V18.5h5.75a1 1 0 1 1 0 2h-6A1.75 1.75 0 0 1 2 18.75V6a1.75 1.75 0 0 1 1.75-1.75h5.001a1.76 1.76 0 0 1 1.043.348l.002.001 2.54 1.901h7.914A1.75 1.75 0 0 1 22 8.25v.375a1 1 0 1 1-2 0V8.5h-7.751a1.76 1.76 0 0 1-1.043-.348l-.002-.001-2.54-1.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.25 15.375a1 1 0 0 1 1-1h.5v-.5a2.875 2.875 0 1 1 5.75 0v.5h.5a1 1 0 0 1 1 1V19.5a1 1 0 0 1-1 1h-6.75a1 1 0 0 1-1-1zm5.25-1v-.5a.875.875 0 1 0-1.75 0v.5zm1.5 2V18.5h-4.75v-2.125z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFolderSimpleLock;